import React from 'react'
import { ReactReduxContext } from 'react-redux'
import wrappedDisplayName from '../../utils/wrapperDisplayName'

/**
 * inject redux store as prop of component
 * uses react-redux v6 React.createContext Consumer
 *
 * @param {Component|StatelessFunction} WrappedComponent - react component to pass store as prop
 * @return {StatelessFunction} WithStoreComponent
 */
const injectStore = WrappedComponent => {
  const WithStore = props => (
    <ReactReduxContext.Consumer>
      {({ store }) => <WrappedComponent store={store} {...props} />}
    </ReactReduxContext.Consumer>
  )

  WithStore.displayName = wrappedDisplayName('withStore', WrappedComponent)

  return WithStore
}

export default injectStore
